import { scaleLinear } from 'd3-scale'

import { ControlStatus } from '@/gen/controls/v1/control_status_pb'
import { RiskLevel } from '@/gen/inventory/v1/risk_pb'
import { ManualQuestionStatus } from '@/gen/questionnaire/v2/model_pb'

import { colors } from '@/const/colors'

const { purple, red, orange, yellow, gray, green, indigo } = colors

export const purpleScale = scaleLinear(
  [0 / 3, 1 / 3, 2 / 3, 3 / 3],
  [purple[200], purple[400], purple[600], purple[800]],
)

export const riskLevelToColor: Record<RiskLevel, string> = {
  [RiskLevel.CRITICAL]: red[500],
  [RiskLevel.HIGH]: orange[400],
  [RiskLevel.MEDIUM]: yellow[300],
  [RiskLevel.LOW]: gray[300],
  [RiskLevel.UNSPECIFIED]: '',
}

export const controlStatusToColor: Record<ControlStatus, string> = {
  [ControlStatus.GAP]: red[300],
  [ControlStatus.VALIDATED]: green[400],
  [ControlStatus.NO_EVIDENCE]: yellow[300],
  [ControlStatus.NOT_EVALUATED]: gray[300],
  [ControlStatus.NOT_APPLICABLE]: gray[300],
  [ControlStatus.ATTESTED]: indigo[400],
  [ControlStatus.UNSPECIFIED]: '',
}

export const controlStatusToTextClassName: Record<ControlStatus, string> = {
  [ControlStatus.GAP]: 'text-main-foreground-danger',
  [ControlStatus.VALIDATED]: 'text-main-foreground-success',
  [ControlStatus.NO_EVIDENCE]: 'text-main-foreground-warning',
  [ControlStatus.NOT_EVALUATED]: 'text-main-foreground-secondary',
  [ControlStatus.NOT_APPLICABLE]: 'text-main-foreground-secondary',
  [ControlStatus.ATTESTED]: 'text-main-foreground-accent',
  [ControlStatus.UNSPECIFIED]: '',
}

export const riskLevelClassNameColor: Record<RiskLevel, string> = {
  [RiskLevel.CRITICAL]: 'text-red-500 border-red-200',
  [RiskLevel.HIGH]: 'text-orange-400 border-orange-200',
  [RiskLevel.MEDIUM]: 'text-yellow-300 border-yellow-200',
  [RiskLevel.LOW]: 'text-gray-400 border-gray-200',
  [RiskLevel.UNSPECIFIED]: '',
}

export const questionStatusToClassNameColor: Record<ManualQuestionStatus, string> = {
  [ManualQuestionStatus.ACCEPTED]: 'bg-semantic-success-500',
  [ManualQuestionStatus.NEEDS_REVIEW]: 'bg-gray-700',
  [ManualQuestionStatus.REJECTED]: 'bg-semantic-danger-500',
  [ManualQuestionStatus.UNANSWERED]: 'bg-gray-400',
  [ManualQuestionStatus.UNSPECIFIED]: '',
}

export const questionStatusColor: Record<ManualQuestionStatus, string> = {
  [ManualQuestionStatus.ACCEPTED]: green[500],
  [ManualQuestionStatus.REJECTED]: red[500],
  [ManualQuestionStatus.NEEDS_REVIEW]: gray[700],
  [ManualQuestionStatus.UNANSWERED]: gray[200],
  [ManualQuestionStatus.UNSPECIFIED]: '',
}
